var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"ondeencontrar"}},[_c('Banner',{attrs:{"contents":_vm.banner}}),_c('Options')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }